// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bgk_a","AdSlotBranding__desktop":"bgk_b","AdSlotBranding__mobile":"bgk_c"};